import { render } from "./ErrorMessage.vue?vue&type=template&id=5d094612&scoped=true"
const script = {}

import "./ErrorMessage.vue?vue&type=style&index=0&id=5d094612&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d094612"]])

export default __exports__